<template>
  <div>
    <template v-if="isIndex">
      <div class="PlanBox">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <!-- 搜索框 -->
        <!-- <div class="searchCon">
              <div class="searchMain">
                <ots-refer
                    :selectList="selectList"
                    :request-form="selectForm"
                    @search="getResult"
                />
              </div>
            </div> -->
        <!-- 列表 -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableOption="tableOption"
            :tableData="tableData"
            :batchOperBtn="batchOperBtn"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>

        <!-- 照片设置 -->
        <ots-custom-dialog :dialog.sync="ImageDialog" title="照片设置" :isFullScreen="fullScreen">
          <template v-slot:content>
            <div class="ImagePop">
              <el-form :model="ImageForm" label-width="160px" :inline="true" ref="form">
                <!-- (1) 人脸校验方式 -->
                <div class="sectionBox">
                  <el-form-item>
                    <el-radio-group v-model="ImageForm.photoContrastType">
                      <el-radio-button label="1" class="examType" >权威库人脸校验</el-radio-button>
                      <el-radio-button label="2" class="examType" >人脸对比校验</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <!-- (2) 人脸对比通过分数 -->
                <div class="sectionBox" v-show="ImageForm.photoContrastType == 2">
                  <el-form-item>
                    <div class="personalCheck section" style="margin-bottom: 0;">
                      <!-- <h1>人脸对比分数</h1> -->
                      <span>人脸对比通过分数</span>
                      <el-input placeholder="请输入" v-model.number="ImageForm.photoContrastPassScore"></el-input>
                      <em>分</em>
                      <p class="numExplit">
                        最低不得低于50分，最大不高于100分。
                      </p>
                    </div>
                  </el-form-item>
                </div>
                <!-- (3) 照片上传次数要求 -->
                <div class="sectionBox">
                  <el-form-item>
                    <div class="personalCheck section" style="margin-bottom: 0;">
                      <span>考生人身核验最多</span>
                      <el-select v-model="ImageForm.photoUploadTimes" placeholder="请选择">
                        <el-option v-for="item in uploadTimesList" :key="item.id" :label="item.value" :value="item.id"></el-option>
                      </el-select>
                      <em style="margin-left: 8px;">次</em>
                      <p class="numExplit screen_P" v-if="ImageForm.photoContrastType == 1">
                        考生上传照片时会和公安部身份证照片进行比对，确认照片是考生本人，如果确认有近照和身份证照片差别巨大的，由老师人工核验。
                      </p>
                      <p class="numExplit screen_P" v-else>
                        考生上传照片时会和学生基础照片进行比对，确认照片是考生本人，如果确认有近照和基础照片差别巨大的，由老师人工核验。
                      </p>
                    </div>
                  </el-form-item>
                </div>
                <!-- (4) 照片配置要求 -->
                <div class="sectionBox">
                  <div class="section">
                    <h1><span style="display: inline-block; width: 155px; text-align: right;">学生照片上传要求</span></h1>
                    <!-- 照片说明 textarea -->
                    <div class="setState">
                      <span>照片说明</span>
                      <el-input
                        placeholder="请输入"
                        @input="$forceUpdate()"
                        v-model="ImageForm.photoDescription"
                        type="textarea"
                      ></el-input>
                    </div>
                    <!-- 格式 jpeg,jpg,png -->
                    <div class="setState">
                      <span>格式</span>
                      <el-checkbox-group
                        v-model="ImageForm.photoFormat"
                        class="df-ac pr"
                        @input="$forceUpdate()"
                      >
                        <el-checkbox label="jpeg"></el-checkbox>
                        <el-checkbox label="jpg"></el-checkbox>
                        <el-checkbox label="png"></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <!-- 大小 K -->
                    <div class="personalCheck">
                      <span>大小 ≤ </span>
                      <el-input placeholder="请输入" @input="$forceUpdate()" v-model.number="ImageForm.photoSize"></el-input><em>k</em>
                    </div>
                    <!-- 标准化 -->
                    <div class="setState">
                      <span>是否开启照片标准化</span>
                      <el-switch
                        v-model="ImageForm.photoStandardNeed"
                        :active-value="1"
                        :inactive-value="0"
                      ></el-switch>
                    </div>
                    <!-- 标准化背景颜色 -->
                    <div class="photoStandardNeed" v-show="ImageForm.photoStandardNeed == 1">
                      <p>背景颜色</p>
                      <el-radio-group v-model="ImageForm.photoStandardBgColor">
                        <el-radio label="蓝色">蓝色</el-radio>
                        <el-radio label="红色">红色</el-radio>
                        <el-radio label="白色">白色</el-radio>
                      </el-radio-group>
                    </div>
                    <!-- 标准化尺寸 -->
                    <div class="photoStandardNeed" v-show="ImageForm.photoStandardNeed == 1">
                      <p>尺寸大小</p>
                      <el-radio-group v-model="ImageForm.photoStandardSize">
                        <el-radio label="一寸">一寸</el-radio>
                        <el-radio label="大一寸">大一寸</el-radio>
                        <el-radio label="小二寸">小二寸</el-radio>
                        <el-radio label="二寸">二寸</el-radio>
                        <el-radio label="大二寸">大二寸</el-radio>
                      </el-radio-group>
                    </div>
                    <!-- **** -->
                  </div>
                </div>
              </el-form>
            </div>
          </template>
          <template v-slot:footer>
            <div style="display: flex; justify-content: center;">
              <el-button round @click="ImageDialog = false">取消</el-button>
              <el-button round type="primary" @click="setPlanImage">确定</el-button>
            </div>
          </template>
        </ots-custom-dialog>
        <!-- 考生范围弹窗 -->
        <!-- 弹窗 -->
        <ots-custom-dialog
          :dialog.sync="studentDialog"
          title="考生范围设置"
          :isFullScreen="fullScreen"
        >
          <template v-slot:content>
            <div class="stuPop">
              <div class="btnBox">
                <el-button type="primary" round @click="importStudentFn">导入</el-button>
              </div>
              <ots-refer
                class="mb16"
                :selectList="stuselectList"
                :request-form="stuselectForm"
                :showAdvanced="4"
                @search="getStuResult"
              />
              <div style="padding: 20px; background: #fff;border-radius:8px">
                <ots-table-group
                  :tableHeader="stutableHeader"
                  :tableOption="stutableOption"
                  :tableData="stutableData"
                  :batchOperBtn="stubatchOperBtn"
                  @handleSelectionChange="stubachOper"
                  :pagination="stupagination"
                  @changeNum="stuchangeSize"
                  @changePage="stuchangePage"
                ></ots-table-group>
              </div>
            </div>
          </template>
        </ots-custom-dialog>

        <!-- 导入考生 -->
        <ots-custom-dialog
          :dialog.sync="importDialog"
          title="导入考生"
          width="40%"
        >
          <template v-slot:content>
            <el-form ref="exportForm" :model="importForm">
              <el-form-item label="1.模板下载">
                <span
                  style="color:#006AFF;"
                  @click="$getStaticFile('考生导入.xlsx')"
                  class="cp"
                >
                  <i class="el-icon-download"></i>
                  下载考生导入数据模板
                </span>
              </el-form-item>
              <el-form-item label="2.选择文件" v-model="importForm.file">
                <ots-upload-file
                  :httpRequest="handleFormData"
                  fileType="xlsx"
                />
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>
                  2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="importDialog = false">取消</el-button>
            <el-button round type="primary" @click="rightImport"
              >确定</el-button
            >
          </template>
        </ots-custom-dialog>

        <!-- 编辑考生 -->
        <ots-custom-dialog
          :dialog.sync="editDialog"
          title="编辑考生"
          width="50%"
        >
          <template v-slot:content>
            <div>
              <el-form :model="stuEditForm" label-width="160px" :inline="true">
                <div class="sectionBox">
                  <el-form-item label="考试批次">
                    <span>{{ currentPlanCode }}</span>
                  </el-form-item>
                  <el-form-item label="学校">
                    <el-select
                      v-model="stuEditForm.schoolId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in schoolData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sectionBox">
                  <el-form-item label="层次">
                    <el-select v-model="stuEditForm.level" placeholder="请选择">
                      <el-option
                        v-for="item in level"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="专业">
                    <el-select
                      v-model="stuEditForm.subjectId"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in subjectData"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="sectionBox">
                  <el-form-item label="姓名">
                    <el-input v-model="stuEditForm.name" />
                  </el-form-item>
                  <el-form-item label="学号">
                    <el-input v-model="stuEditForm.studyId" />
                  </el-form-item>
                </div>
                <div class="sectionBox">
                  <el-form-item label="证件类型">
                    <el-select
                      v-model="stuEditForm.cardType"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in cardTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="证件号码">
                    <el-input v-model="stuEditForm.cardNo" />
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="editDialog = false">取消</el-button>
            <el-button round type="primary" @click="editStuFn">确定</el-button>
          </template>
        </ots-custom-dialog>

        <!-- 查看考生 -->
        <ots-custom-dialog
          :dialog.sync="checkDialog"
          title="查看考生"
          width="50%"
        >
          <template v-slot:content>
            <div>
              <el-form :model="stuEditForm" label-width="160px" :inline="true">
                <div class="sectionBox">
                  <el-form-item label="考试批次">
                    <span>{{ currentPlanCode }}</span>
                  </el-form-item>
                  <el-form-item label="学校">
                    <span>{{ currentStu.schoolName }}</span>
                  </el-form-item>
                </div>
                <div class="sectionBox">
                  <el-form-item label="层次">
                    <span>{{ currentStu.level }}</span>
                  </el-form-item>
                  <el-form-item label="专业">
                    <span>{{ currentStu.subjectName }}</span>
                  </el-form-item>
                </div>
                <div class="sectionBox">
                  <el-form-item label="姓名">
                    <span>{{ currentStu.name }}</span>
                  </el-form-item>
                  <el-form-item label="学号">
                    <span>{{ currentStu.studyId }}</span>
                  </el-form-item>
                </div>
                <div class="sectionBox">
                  <el-form-item label="证件类型">
                    <span>{{
                      cardTypeList[currentStu.cardType - 1].name
                    }}</span>
                  </el-form-item>
                  <el-form-item label="证件号码">
                    <span>{{ currentStu.cardNo }}</span>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round type="primary" @click="checkDialog = false">关闭</el-button>
          </template>
        </ots-custom-dialog>

        <!-- 考试科目例外设置 -->
        <ots-custom-dialog
          :dialog.sync="exceptionDialog"
          title="考试科目例外设置"
          width="60%"
        >
          <template v-slot:content>
            <div>
              <div style="display: flex; justify-content: space-between; height: 36px; font-size: 14px; font-weight: 700; color: #303133;">
                <span style="display: block; width: 140px;">考试科目</span>
                <span style="display: block; width: 240px;">是否需要特殊输入法</span>
                <span style="display: block; width: 160px;">是否需要计算器</span>
                <span style="display: block; width: 160px;">是否需要麦克风</span>
              </div>
              <div style="display: flex; justify-content: space-between; height: 36px;" v-for="(item, index) in courseList" :key="index">
                <span style="display: block; width: 140px;">{{item.courseName}}</span>
                <div style="width: 240px;">
                  <el-radio v-model="item.specialInputting" :label="null">不需要</el-radio>
                  <el-radio v-model="item.specialInputting" v-for="v in Specials" :key="v.inputCode" :label="v.inputCode">{{v.inputName}}</el-radio>
                </div>
                <div style="width: 160px;">
                  <el-radio v-model="item.useCalculator" :label="1">是</el-radio>
                  <el-radio v-model="item.useCalculator" :label="0">否</el-radio>
                </div>
                <div style="width: 160px;">
                  <el-radio v-model="item.useMicroPhone" :label="1">是</el-radio>
                  <el-radio v-model="item.useMicroPhone" :label="0">否</el-radio>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round type="primary" @click="exceptionDialog = false">取消</el-button> 
            <el-button round type="primary" @click="resetCourseSet">确定</el-button>
          </template>
        </ots-custom-dialog>
        <!-- 发布考试批次--确认缴费方式 -->
        <!-- <ots-custom-dialog :dialog.sync="publishDialog" title="系统提示" width="50%">
                <template v-slot:content>
                    <div v-if="needPayment == 1">该批次的缴费方式为<span class="col_black fb">{{`"${paymentType == 2 ? '线下缴费' : '线上缴费'}"`}}</span>。</div>
                    <div v-else>当前为无需缴费状态，如有需要，请前往<span class="col_black fb">"编辑"</span>中开启缴费配置。</div>
                </template>
                <template v-slot:footer>
                    <el-button round @click="isEditPayType()">{{ needPayment == 1 ? '修改' : '编辑' }}缴费方式</el-button>
                    <el-button round type="primary" @click="publishPlan(selectPlan)">确定</el-button>
                </template>
            </ots-custom-dialog> -->

      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import {
  getPagePlan,
  deletePlanFn,
  editPlanStateFn,
  getPlanStudentFn,
  importStudent,
  deleteStudentFn,
  editStudentFn,
  stopPlanFn,
  getSinglePlan,
  updatePlanPhotoSetApi
} from "@/http/modules/examSet/examBatch";

import { getPlanCourseFn, updatePlanCourseAPI, getSpecialInputtingAPI  } from '@/http/modules/baseSet/course'

import { mapActions, mapState } from "vuex";
export default {
  name: "examBatch",
  data() {
    return {
      // 照片设置 => 考生人身核验下拉
      uploadTimesList: [
        {id: 0, value: 0},
        {id: 1, value: 1},
        {id: 2, value: 2},
        {id: 3, value: 3},
      ],
      // 照片设置 => 绑定参数
      ImageForm: {
        planId: "",
        photoContrastPassScore: 70,
        photoContrastType: "",
        photoUploadTimes: "",
        photoDescription: "",
        photoFormat: "",
        photoSize: "",
        photoStandardNeed: "",
        photoStandardBgColor: "",
        photoStandardSize: "",
      },
      // 照片设置 => 照片设置弹窗
      ImageDialog: false,
      importDialog: false,
      editDialog: false,
      checkDialog: false,
      publishDialog: false,
      fullScreen: true,
      studentSet: true,
      paymentType: "",
      currentPlanId: "",
      currentPlanCode: "",
      importForm: {
        file: "",
      },
      studentSelectList: [],
      stuselectList: [
        // {
        //   title: "学校",
        //   type: "select",
        //   requestKey: "schoolId",
        //   label: 'name',
        //   value: 'id',
        //   data: [],
        // },
        // {
        //   title: "专业",
        //   type: "select",
        //   requestKey: "subjectId",
        //   label: 'name',
        //   value: 'id',
        //   data: [],
        // },
        // {
        //   title: "层次",
        //   type: "select",
        //   requestKey: "level",
        //   label: 'name',
        //   value: 'name',
        //   data: [],
        // },
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名或证件号",
          requestKey: "searchKey",
        },
      ],
      stuselectForm: {
        subjectId: "",
        schoolId: "",
        level: "",
        searchKey: "",
      },
      selectForm: {
        state: "",
        searchKey: "",
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "code",
        },
        {
          title: "批次名称",
          prop: "name",
        },
        // {
        //   title:"收费标准(元)",
        //   prop: "money"
        // },
        {
          title: "启用状态",
          prop: "state",
          formatter: (val) => (val.row.state == 1 ? "启用" : "停用"),
        },
        {
          title: "考试批次状态",
          prop: "planStateName",
        },
        {
          title: "考试类型",
          prop: "examTypeName" 
        },
        {
          title: "照片设置",
          type: "button",
          prop: "",
          formatter: () => "设置",
          click: this.setSystemImage,
        },
        {
          title: "考试科目例外设置",
          type: "button",
          prop: "",
          formatter: () => "查看",
          click: this.setExamSubjectException,
        },
        {
          title: "考生范围",
          type: "button",
          prop: "",
          formatter: () => "设置",
          disableFn: () => this.studentSet,
          click: this.setStudent,
        },
        // {
        //   title: "发布状态",
        //   type: "button",
        //   prop: "publish",
        //   formatter: (val) =>
        //     val.row.publish == 1 ? "已发布" : "<span>发布</span>",
        //   disableFn: (val) => (val.row.publish == 1 ? true : false),
        //   // click: this.publishStart
        //   click: this.publishPlan,
        // },
        {
          title: "操作",
          type: "buttons",
          width: "260",
          btnList: [
            {
              title: "发布",
              click: this.publishPlan,
              disableFn: (val) => (val.row.planState == 1 ? false : true),
            },
            {
              title: "查看",
              click: this.checkBatch,
            },
            {
              title: "编辑",
              click: this.editPlan,
            },
            {
              title: "删除",
              disableFn: (val) =>
                val.row.planState == 1 || val.row.planState == 2 ? false : true,
              click: this.deletePlan,
            },
            {
              //启用状态为启动且已发布 可以停用
              title: "停用",
              click: this.stopPlan,
              disableFn: (val) => {
                if (
                  val.row.state == 1 &&
                  ["2", "3", "4", "5", "6"].indexOf(val.row.planState) !== -1
                ) {
                  return false;
                }
                return true;
              },
            },
          ],
        },
      ],
      tableOption: {
        // multiple:true
      },
      batchOperBtn: [
        //   {
        //       title: "导出",
        //       icon: "iconfont icon-daochu",
        //       click: this.exportPlan
        //   },
        // {
        //     title: "删除",
        //     icon: "iconfont icon-shanchu",
        //     click: this.deletePlan
        // },
      ],
      stubatchOperBtn: [
        {
          title: "删除",
          icon: "iconfont icon-shanchu",
          click: this.deleteStudent,
        },
      ],
      tableData: [],
      stutableData: [],
      stutableHeader: [
        {
          title: "姓名",
          prop: "name",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "证件类型",
          prop: "cardType",
        },
        // {
        //     title:"学号",
        //     prop: "studyId"
        // },
        // {
        //     title:"学校",
        //     prop: "schoolName"
        // },
        // {
        //     title:"专业",
        //     prop: "subjectName"
        // },
        // {
        //     title:"层次",
        //     prop: "level"
        // },
        {
          title: "操作",
          type: "buttons",
          width: "80",
          btnList: [
            // {
            //     title: "查看",
            //     click: this.checkStudent
            // },
            // {
            //     title:"编辑",
            //     click: this.editStudent
            // },
            {
              title: "删除",
              click: this.deleteStudent,
            },
          ],
        },
      ],
      stutableOption: {
        multiple: true,
      },
      form: {
        name: "",
        state: -1,
      },
      mainTopBtnList: [
        {
          title: "新增",
          fn: this.addPlanDialog,
        },
      ],
      studentDialog: false,
      pagination: {
        total: 0,
        page: 1,
      },
      stupagination: {
        total: 0,
      },
      PlanListParams: {
        order: "",
        page: 1,
        size: 10,
      },
      stuListParams: {
        page: 1,
        size: 10,
      },
      subjectData: [],
      schoolData: [],
      stuEditForm: {
        schoolId: "",
        level: "",
        subjectId: "",
        name: "",
        studyId: "",
        cardNo: "",
        cardType: 1,
      },
      currentStu: {
        schoolName: "",
        level: "",
        subjectName: "",
        name: "",
        studyId: "",
        cardNo: "",
        cardType: 1,
      },
      needPayment: "",

      // 考试科目例外设置
      exceptionDialog: false,
      courseList: [],
      exception_PlanId: "",
      Specials: [],
    };
  },
  computed: {
    ...mapState(["level", "cardTypeList"]),
    isIndex() {
      return this.$route.name == "examBatch";
    },
  },
  watch: {
    $route: "getPath",
    // 照片设置 => 人脸校验方式
    // "ImageForm.photoContrastType": "resetPhotoConfig"
  },
  created() {
    this.getAllPlanFn();
    this.getConfig();
    this.getSpecialInputting();

  },

  methods: {
    ...mapActions("currentPlan", ["getCurrentPlanAction"]),
    ...mapActions("selectOptions", ["getSelectPlanAction"]),

    // 人脸对比方式变动 => 修改 `核验次数` 配置
    // async resetPhotoConfig(flag) {
      // (1) 核验次数下拉菜单
      // this.uploadTimesList = flag == 1 ? this.uploadTimesList_01: this.uploadTimesList_02;
      // (2) 核验次数
      // this.ImageForm.photoUploadTimes = this.planInfo.photoUploadTimes ? this.planInfo.photoUploadTimes: flag == 1 ? 3: 5;
      // (3) 权威库核验次数上限
      // if (this.ImageForm.photoUploadTimes > 3 && flag == 1) this.ImageForm.photoUploadTimes = 3;
    // },

    // 考试科目例外设置 (特殊输入法数据获取)
    async getSpecialInputting() {
      const { data } = await getSpecialInputtingAPI();
      this.Specials = data;
    },

    // 考试科目例外设置 (保存 + 关闭弹窗 + 成功提示)
    async resetCourseSet() {
      let params = {
        planId: this.exception_PlanId,
        planCourseList: JSON.stringify(this.courseList),
      }
      const { code } = await updatePlanCourseAPI(params);
      if (code == 1) {
        this.$message.success("考试科目例外设置成功。");
        this.exceptionDialog = false;
      }
    },

    // 考试科目例外设置 (查询 + 打开弹窗)
    async setExamSubjectException(row) {
      // 获取课程列表
      const { data } = await getPlanCourseFn({planId: row.id});
      this.exception_PlanId = row.id;
      this.courseList = data;
      this.exceptionDialog = true;
    },

    // 照片设置
    async setSystemImage(row) {
      let planId = row.id;
      let { data: planInfo } = await getSinglePlan({ planId });
      this.planInfo = planInfo;

      // 批次
      this.ImageForm.planId = planId;
      // 照片比对方式
      this.ImageForm.photoContrastType = planInfo.photoContrastType;
      // 对比分数
      this.ImageForm.photoContrastPassScore = planInfo.photoContrastPassScore ? planInfo.photoContrastPassScore: 70;
      // 考生人身核验最多次数
      this.ImageForm.photoUploadTimes = planInfo.photoUploadTimes || planInfo.photoUploadTimes === 0 ? planInfo.photoUploadTimes: 3;
      // 照片说明
      this.ImageForm.photoDescription = planInfo.photoDescription ? planInfo.photoDescription: `1、必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上传成功。`;
      // 格式
      this.ImageForm.photoFormat = planInfo.photoFormat.split(",").length > 0 ? planInfo.photoFormat.split(",") : ["jpeg", "jpg", "png"];
      // 大小
      this.ImageForm.photoSize = planInfo.photoSize ? planInfo.photoSize : 2056;
      // 标准化
      this.ImageForm.photoStandardNeed = planInfo.photoStandardNeed == 1 ? 1: 0;
      // 背景颜色
      this.ImageForm.photoStandardBgColor = planInfo.standardPhotoModel.photoBgColor;
      // 照片尺寸
      this.ImageForm.photoStandardSize = planInfo.standardPhotoModel.photoSize;

      this.ImageDialog = true;
    },

    // 照片设置 -保存
    async setPlanImage() {
      // (1) 人脸对比分数
      let scoreFlag = this.photoContrastPassScoreBlur();
      if (!scoreFlag) return;
      // (2) 参数
      let params = JSON.parse(JSON.stringify(this.ImageForm));
      params.photoFormat = params.photoFormat.join(",");
      // (3) 保存
      let { code } = await updatePlanPhotoSetApi(params);
      // (4) 人脸校验方式不同, 提示不同
      let flag = params.photoContrastType;
      if (code !== 0) {
        if (flag == 1) {
          this.$message.success("“照片设置” 保存成功！");
        } else {
          this.$message.success("请及时在报名管理中导入基础照片，便于学生上传照片进行比对！");
        }
      }
      this.ImageDialog = false;
    },

    // 人脸对比通过分数
    photoContrastPassScoreBlur() {
      let score = this.ImageForm.photoContrastPassScore;
      if (Number(score) !== Number(score)) {
        this.$message.warning("请输入正确的“人脸对比通过分数”。");
        return false;
      } else if (score < 50 || score > 100) {
        this.$message.warning("人脸对比通过分数 “最低不得低于50分，最大不高于100分”。");
        this.ImageForm.photoContrastPassScore = 70;
        return false;
      } else {
        return true;
      }
    },

    //停用
    async stopPlan(row) {
      this.$confirm("确定关闭该考试批次吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { code } = await stopPlanFn({ planId: row.id });
        if (code == 1) {
          this.$message.success("停用成功");
          this.getAllPlanFn();
        }
      });
    },

    // 发布 => 编辑缴费方式 => 考试批次编辑
    isEditPayType() {
      this.$router.push({
        name: "editBatch",
        query: { id: this.selectPlan.id },
      });
    },

    // 考生范围 ==> 设置 ==> 导入按钮
    async rightImport() {
      if (!this.importForm.planId) {
        this.$message.error("请退出重试");
        return;
      }
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      const { code, data } = await importStudent(fd);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
        this.importDialog = false;
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.getStudent();
      }
    },

    // 考生范围 ==> 设置 ==> 导入 ==> 文件处理
    handleFormData(val) {
      this.importForm.planId = this.currentPlanId;
      this.importForm.file = val.file;
    },

    // 考生范围 ==> 设置 ==> 删除
    deleteStudent(row) {
      if (!(row || this.beforeBatch())) {
        return false;
      }
      let param = {
        planId: this.currentPlanId,
        cardNoList: row ? row.cardNo : this.studentSelectList.join(),
      };
      this.$confirm("确定删除考生?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const { code } = await deleteStudentFn(param);
        if (code == 1) {
          this.$message.success("删除成功");
          this.getStudent();
        }
      });
    },

    // 考生范围 ==> 设置 ==> 开启导入弹窗
    importStudentFn() {
      this.importDialog = true;
    },

    // 考生范围 ==> 设置
    setStudent(row) {
      this.currentPlanId = row.id;
      this.currentPlanCode = row.code;
      this.stuselectForm = {
        subjectId: "",
        schoolId: "",
        level: "",
        searchKey: "",
      };
      this.stuListParams = {
        planId: this.currentPlanId,
        page: 1,
        size: 10,
      };
      this.getStudent();
      this.studentDialog = true;
    },

    // 考生范围 ==> 设置 ==> 考生数据
    async getStudent() {
      let params = Object.assign(this.stuListParams, this.stuselectForm);
      const { data } = await getPlanStudentFn(params);
      this.stutableData = data.records;
      this.stupagination.total = data.total;
    },

    // 考生范围 ==> 设置 ==> 编辑考生
    editStudent(row) {
      this.editDialog = true;
      for (let key in this.stuEditForm) {
        this.stuEditForm[key] = "";
        this.stuEditForm[key] = row[key] ? row[key] : this.stuEditForm[key];
      }
    },

    // 考生范围 ==> 设置 ==> 编辑考生 ==> 确认
    async editStuFn() {
      this.stuEditForm.planId = this.currentPlanId;
      const { code } = await editStudentFn(this.stuEditForm);
      if (code == 1) {
        this.$message.success("修改成功");
        this.editDialog = false;
        this.getStudent();
      }
    },

    // 获取全部批次
    getPath() {
      if (this.$route.name == "examBatch") {
        this.getAllPlanFn();
      }
    },
    async getAllPlanFn() {
      this.PlanListParams = Object.assign(this.PlanListParams, this.selectForm);
      const { data } = await getPagePlan(this.PlanListParams);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },

    // 发布状态 ==> 确认发布
    async publishPlan(row) {
      this.$confirm(
        "发布后考试批次不可删除且部分信息不可编辑，确定发布该考试批次?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const { code } = await editPlanStateFn({ planId: row.id });
          if (code == 1) {
            this.$message.success("发布成功");
            this.getAllPlanFn();
            this.getCurrentPlanAction();
            this.getSelectPlanAction();
          }
          this.publishDialog = false;
        })
        .catch(() => {
          this.publishDialog = false;
        });
    },

    // 考生范围 ==> 查看考生信息
    checkStudent(row) {
      this.checkDialog = true;
      for (let key in this.currentStu) {
        this.currentStu[key] = "";
        this.currentStu[key] = row[key] ? row[key] : this.currentStu[key];
      }
    },

    // 考生范围 ==> 设置 ==> 考生表格 ==> 勾选
    stubachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.cardNo);
      });
      this.studentSelectList = idList;
    },

    // 新增考试批次
    addPlanDialog() {
      this.$router.push({
        name: "addBatch",
      });
    },

    // 查看考试批次
    checkBatch(row) {
      this.$router.push({
        name: "checkBatch",
        query: {
          id: row.id,
        },
      });
    },

    // 编辑考试批次
    editPlan(row) {
      this.$router.push({
        name: "editBatch",
        query: {
          id: row.id,
        },
      });
    },

    // 发布考试批次
    publishStart(row) {
      this.needPayment = row.isPay;
      this.selectPlan = row;
      this.publishDialog = true;
      this.paymentType = row.payType;
    },

    // 考生范围 ==> 设置 ==> 删除 ==> 是否勾选考生
    beforeBatch() {
      if (this.studentSelectList.length > 0) {
        return true;
      } else {
        this.$message.warning("请先选择考生");
        return false;
      }
    },

    // 删除考试批次
    async deletePlan(row) {
      this.$confirm("确定删除该考试批次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code } = await deletePlanFn({ planId: row.id });
          if (code == 1) {
            this.$message.success("删除成功");
            this.updataSelectPlanFlag = true;
            this.getAllPlanFn();
          }
        })
        .catch(() => {});
    },

    // 考生范围 ==> 设置 ==> 院校信息
    initStuLimitData() {
      this.mixin_getSelectSchool().then((data) => {
        this.schoolData = data;
        this.stuselectList[0].data = data;
      });
    },

    // 发布 ==> 编辑缴费方式 ==> 系统设置
    getConfig() {
      this.$api.system.getConfigData().then((res) => {
        let configList = res.data.configList;
        configList.forEach((item) => {
          // if (item.setName == "onlinePayment") {
          //   this.paymentType = item.setValue
          // }
          if (item.setName == "needRegion") {
            this.studentSet = item.setValue == 1 ? false : true;
          }
          // if (item.setName == 'needPayment') {
          //   this.needPayment = item.setValue;
          // }
        });
      });
    },

    // 考生范围 ==> 设置 ==> 专业列表
    initSubject() {
      this.mixin_getSelectSubject().then((data) => {
        this.subjectData = data;
        this.stuselectList[1].data = data;
      });
    },

    resetForm() {
      this.form = {
        name: "",
        state: -1,
      };
    },
    addAfter() {},
    changeSize(num) {
      this.PlanListParams.size = num;
      this.getAllPlanFn();
    },
    changePage(p) {
      this.PlanListParams.page = p;
      this.pagination.page = p;
      this.getAllPlanFn();
    },
    stuchangeSize(num) {
      this.stuListParams.size = num;
      this.getStudent();
    },
    stuchangePage(p) {
      this.stuListParams.page = p;
      this.getStudent();
    },
    getStuResult() {
      this.stuListParams.page = 1;
      this.getStudent();
    },
  },
};
</script>
<style lang="less" scoped>
.PlanBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .searchCon {
    padding: 20px;
    margin-bottom: 16px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .searchMain {
      flex: 1;
    }
    .searchBtn {
      flex-shrink: 0;
      width: 72px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mainCon {
    margin-top: 0;
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
    flex: 1;
  }
}
.stuPop {
  .btnBox {
    margin-top: 16px;
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.sectionBox {
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  flex-wrap: wrap;
  .el-form-item {
    flex: 1;
  }
}



// 照片设置样式

.ImagePop {
  padding: 24px;
  font-family: "PingFangSC-Regular, PingFang SC";
  background: #FFF;
  border-radius: 8px;
  margin-top: 16px;
  .examType {
    width: 128px;
    margin-right: 16px;
    /deep/ .el-radio-button__inner {
      width: 100%;
      font-size: 13px;
    }
  }
  .photoStandardNeed {
    display: flex;
    margin-bottom: 40px;
    p {
      margin: 10px 16px 10px 5px;
      width: 140px;
      text-align: right;
    }
    div {
      margin-top: 15px;
    }
  }
  .setState,.personalCheck {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 40px;
    p {
      a:first-child {
        text-decoration: underline;
      }
      a {
        color: #45494d;
      }
    }
    i{
      margin-left: 10px;
      font-style: normal;
    }
    span {
      display: block;
      width: 155px !important;
      color: #45494d;
      text-align: right;
      margin-right: 16px;
    }
    .el-input {
      width: 160px;
      height: 36px;
    }
    em {
      position: relative;
      margin-left: -24px;
      z-index: 1;
      font-style: normal;
    }
  }
  .numExplit {
    font-size: 14px;
    color: #9299a6;
    margin-left: 16px;
  }
  @media screen and (max-width: 1320px){
    .screen_P {
      width: 100%;
      margin-left: 170px;
      margin-top: 8px;
      line-height: 18px;
    }
  }
  .section {
    h1 {
      color: #2d2f33;
      font-size: 14px;
      font-weight: 500;
      // margin-bottom: 40px;
      width: 100%;
    }
    span {
      line-height: 35px;
    }
  }

  /deep/ .el-input .el-input__inner {
    width: 160px;
    height: 36px;
    line-height: 18px;
  }
  /deep/ .el-input {
    width: 160px !important;
  }
  /deep/ .el-textarea {
    width: 500px;
  }
  /deep/ .el-textarea__inner {
    width: 500px !important;
    height: 100px;
  }
  /deep/ .el-radio-button__inner {
    margin-right: 8px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    padding: 10px 20px;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }

  /deep/ .el-checkbox-button__inner {
    margin-right: 8px;
  }

}

</style>
